import React from 'react';

type CollapsibleProps = {
    children: React.ReactNode;
    visible: boolean;
};
export const Collapsible = ({ children, visible }: CollapsibleProps) => {
    const [height, setHeight] = React.useState(0);
    const divRef = React.useRef<HTMLDivElement>(null);
    React.useLayoutEffect(() => {
        const node = divRef.current;
        if (visible && node) {
            node.style.height = 'auto';
            const calcHeight = node.getBoundingClientRect().height;
            node.style.height = '0';
            window.requestAnimationFrame(() => setHeight(calcHeight));
        } else {
            setHeight(0);
        }
    }, [visible]);
    return (
        <div
            ref={divRef}
            style={{
                height,
                overflow: 'hidden',
                transition: 'height 0.2s ease-in-out',
            }}
        >
            {children}
        </div>
    );
};
